angular.module('App')
    .directive('descriptionRow', function factory() {
        var directiveDefinitionObject = {
            templateUrl: "js/directives/descriptionRow.html",
            scope: {
                data: "@"
            },

            link: function postLink(scope, iElement, iAttrs) {

            }
        };
        return directiveDefinitionObject;
    })
    .directive('rowHeaderMin', function factory() {
        var directiveDefinitionObject = {
            restrict: "A",
            scope: {
                libelle1: "@",
                libelle2: "@",
                libelle3: "@",
                libelle4: "@",
                libelle5: "@"
            },

            link: function postLink(scope, iElement, iAttrs) {

            },
            templateUrl: "js/directives/rowHeaderMin.html"
        };
        return directiveDefinitionObject;
    })
    .directive('rowNumberWithRotationCroissance', function factory() {
        var directiveDefinitionObject = {
            restrict: "A",
            scope: {
                data: "=",
                libelle: "@",
                italic: "@",
                tabulation: "@",
                decimal: "@?"
            },

            link: function postLink(scope, iElement, iAttrs) {
                scope.decimal = scope.decimal || 0;

                if (_.isNil(scope.italic)) scope.italic = false;
                if (_.isNil(scope.tabulation)) scope.tabulation = false;
                if (_.isNil(scope.libelle)) scope.libelle = "";

                if (scope.data) {
                    if (_.isNil(scope.data.DE)) scope.DEhide = true;
                    if (_.isNil(scope.data.AT)) scope.AThide = true;
                    if (_.isNil(scope.data.PA)) scope.PAhide = true;
                    if (_.isNil(scope.data.ON)) scope.ONhide = true;
                }
            },
            templateUrl: "js/directives/rowNumberWithRotationCroissance.html"
        };
        return directiveDefinitionObject;
    })
    .directive('rowPercentWithRotationCroissance', function factory() {
        var directiveDefinitionObject = {
            restrict: "A",
            scope: {
                data: "=",
                libelle: "@",
                italic: "@",
                tabulation: "@",
                decimal: "@?"
            },

            link: function postLink(scope, iElement, iAttrs) {
                scope.decimal = scope.decimal || 0;

                if (_.isNil(scope.italic)) scope.italic = false;
                if (_.isNil(scope.tabulation)) scope.tabulation = false;
                if (_.isNil(scope.libelle)) scope.libelle = "";

                if (scope.data) {
                    if (_.isNil(scope.data.DE)) scope.DEhide = true;
                    if (_.isNil(scope.data.AT)) scope.AThide = true;
                    if (_.isNil(scope.data.PA)) scope.PAhide = true;
                    if (_.isNil(scope.data.ON)) scope.ONhide = true;
                }
            },
            templateUrl: "js/directives/rowPercentWithRotationCroissance.html"
        };
        return directiveDefinitionObject;
    })
    .directive('rowPercent', function factory() {
        var directiveDefinitionObject = {
            restrict: "A",
            scope: {
                data: "=",
                libelle: "@",
                italic: "@",
                tabulation: "@",
                decimal: "@?"
            },

            link: function postLink(scope, iElement, iAttrs) {
                scope.decimal = scope.decimal || 0;

                if (_.isNil(scope.italic)) scope.italic = false;
                if (_.isNil(scope.tabulation)) scope.tabulation = false;
                if (_.isNil(scope.libelle)) scope.libelle = "";

                if (scope.data) {
                    if (_.isNil(scope.data.DE)) scope.DEhide = true;
                    if (_.isNil(scope.data.AT)) scope.AThide = true;
                    if (_.isNil(scope.data.PA)) scope.PAhide = true;
                    if (_.isNil(scope.data.ON)) scope.ONhide = true;
                }

            },
            templateUrl: "js/directives/rowPercent.html"
        };
        return directiveDefinitionObject;
    })
    .directive('rowData', function factory() {
        var directiveDefinitionObject = {
            restrict: "A",
            scope: {
                data: "=",
                libelle: "@",
                italic: "@",
                tabulation: "@"
            },

            link: function postLink(scope, iElement, iAttrs) {
                if (_.isNil(scope.italic)) scope.italic = false;
                if (_.isNil(scope.tabulation)) scope.tabulation = false;
                if (_.isNil(scope.libelle)) scope.libelle = "";

                if (scope.data) {
                    if (_.isNil(scope.data.DE)) scope.DEhide = true;
                    if (_.isNil(scope.data.AT)) scope.AThide = true;
                    if (_.isNil(scope.data.PA)) scope.PAhide = true;
                    if (_.isNil(scope.data.ON)) scope.ONhide = true;
                }
            },
            templateUrl: "js/directives/rowData.html"
        };
        return directiveDefinitionObject;
    })
    .directive('rowData3Col', function factory() {
        var directiveDefinitionObject = {
            restrict: "A",
            scope: {
                data: "=",
                libelle: "@",
                italic: "@",
                tabulation: "@",
                decimal: "@?"
            },

            link: function postLink(scope, iElement, iAttrs) {
                scope.decimal = scope.decimal || 0;

                if (_.isNil(scope.italic)) scope.italic = false;
                if (_.isNil(scope.tabulation)) scope.tabulation = false;
                if (_.isNil(scope.libelle)) scope.libelle = "";

                if (scope.data) {
                    if (_.isNil(scope.data.TERRITOIRE)) scope.TERRITOIREhide = true;
                    if (_.isNil(scope.data.DEPARTEMENT)) scope.DEPARTEMENThide = true;
                }
            },
            templateUrl: "js/directives/rowData3Col.html"
        };
        return directiveDefinitionObject;
    })
    .directive('rowPercent3Col', function factory() {
        var directiveDefinitionObject = {
            restrict: "A",
            scope: {
                data: "=",
                libelle: "@",
                italic: "@",
                tabulation: "@",
                decimal: "@?"
            },

            link: function postLink(scope, iElement, iAttrs) {
                scope.decimal = scope.decimal || 0;

                if (_.isNil(scope.italic)) scope.italic = false;
                if (_.isNil(scope.tabulation)) scope.tabulation = false;
                if (_.isNil(scope.libelle)) scope.libelle = "";
            },
            templateUrl: "js/directives/rowPercent3Col.html"
        };
        return directiveDefinitionObject;
    })
    .directive('rowData4Col', function factory() {
        var directiveDefinitionObject = {
            restrict: "A",
            scope: {
                data: "=",
                libelle: "@",
                italic: "@",
                tabulation: "@",
                decimal: "@?"
            },

            link: function postLink(scope, iElement, iAttrs) {
                scope.decimal = scope.decimal || 0;

                if (_.isNil(scope.italic)) scope.italic = false;
                if (_.isNil(scope.tabulation)) scope.tabulation = false;
                if (_.isNil(scope.libelle)) scope.libelle = "";

                if (scope.data) {
                    if (_.isNil(scope.data.OLS)) scope.OLShide = true;
                    if (_.isNil(scope.data.PA)) scope.PAhide = true;
                    if (_.isNil(scope.data.PDM)) scope.PDMhide = true;
                }
            },
            templateUrl: "js/directives/rowData4Col.html"
        };
        return directiveDefinitionObject;
    })
    .directive('rowPercent4Col', function factory() {
        var directiveDefinitionObject = {
            restrict: "A",
            scope: {
                data: "=",
                libelle: "@",
                italic: "@",
                tabulation: "@",
                decimal: "@?"
            },

            link: function postLink(scope, iElement, iAttrs) {
                scope.decimal = scope.decimal || 0;
                if (_.isNil(scope.italic)) scope.italic = false;
                if (_.isNil(scope.tabulation)) scope.tabulation = false;
                if (_.isNil(scope.libelle)) scope.libelle = "";

                if (scope.data) {
                    if (_.isNil(scope.data.OLS)) scope.OLShide = true;
                    if (_.isNil(scope.data.PA)) scope.PAhide = true;
                    if (_.isNil(scope.data.PDM)) scope.PDMhide = true;
                }
            },
            templateUrl: "js/directives/rowPercent4Col.html"
        };
        return directiveDefinitionObject;
    });



// WEBPACK FOOTER //
// ./resources/assets/js/directives/templateRow.ts